import { bool, string } from '@philips-internal/oswald-ui-core/lib/component/prop-types/index.js';
const SuppressHeadingMarginProperties = {
    applyLeftPadding: {
        defaultValue: false,
        type: bool,
    },
    applyRightPadding: {
        defaultValue: false,
        type: bool,
    },
    uuid: {
        defaultValue: '',
        type: string,
    },
};
export { SuppressHeadingMarginProperties, };
//# sourceMappingURL=suppress-heading-margin-types.js.map